import { createContext } from "react";
export var initialContext = {
    defaultInterval: 4000,
    width: 360,
    height: 640
};
var GlobalContext = createContext(initialContext);
export default GlobalContext;
